export default __webpack_public_path__ + "static/media/logo-white.fe4a9da5.png";